// @vendors
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

// @components
import Button from '../../../components/atoms/Button';
import routesConfig from '../../../config/routes.config';

const ServicesHero = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();

    const renderCollage = (additionalClasses: string) => (
        <div className={`w-full lg:p-4 xl:p-8 ${additionalClasses}`}>
            <div className="animate-scroll">
                <img
                    src="/assets/img/landing-page/collage.png"
                    alt="banner collage"
                    className="w-full h-28 object-cover"
                />
            </div>
        </div>
    );

    return (
        <div className="flex mt-4 xl:mt-10  flex-col gap-4 p-4 items-center w-full overflow-hidden bg-cBackground dark:bg-dark-cBackground border border-cBorder dark:border-dark-cBorder lg:w-fit lg:mx-20 rounded-md lg:rounded-2xl xl:relative">
            {renderCollage("opacity-60")}
            <div className="flex flex-col items-center text-center gap-4 xl:relative xl:z-10 xl:max-w-3xl xl:mx-auto xl:px-2 xl:my-5">
                <h1 className="text-[15px]  font-semibold text-cText dark:text-dark-cText lg:text-[20px] xl:font-bond">
                    {t('landingPage.servicesHero.title')}
                </h1>
                <p className="text-[20] text-cTextSecondary dark:text-dark-cTextSecondary">
                    {t('landingPage.servicesHero.subtitle')}
                </p>
                <Button
                    onClick={() => navigate(routesConfig.marketplaceUser)}
                    uppercase
                    size='small'
                >
                    {t('landingPage.servicesHero.buttonText')}
                </Button>
            </div>
            {renderCollage("xl:mt-2 opacity-60")}
        </div>
    );
};

export default ServicesHero;